import type { ComputedRef, InjectionKey } from 'vue';

export type CollapsibleState = 'open' | 'closed';

export interface CollapsibleContext {
    open: ComputedRef<boolean>;
    disabled: ComputedRef<boolean>;
    contentId: string;
    toggle: () => void;
}

export const collapsibleKey: InjectionKey<CollapsibleContext> = Symbol('Collapsible');

export const useCollapsibleContext = (part: string): CollapsibleContext => {
    const context = inject(collapsibleKey, null);
    if (!context) throw new Error(`<${part}> must be used inside <Collapsible>`);

    return context;
};
